import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const bacsFileManagementRoute: RouteConfig<'with-page'> = {
    name: 'BACs File Management',
    path: '/finance/bacs-files-management',
    page: lazy(() => import('.')),
    roles: ['ncassAdmin'],
}